import { useQuery } from '@tanstack/react-query';
import { useAuthedFetch, parseJsonOrThrow } from './client';
import { ListFaultsResponse } from '../domain';

export function useFaultsQuery(includeCleared = false) {
  const fetcher = useAuthedFetch();
  return useQuery({
    queryKey: ['faults', includeCleared],
    queryFn: async () => {
      const res = await fetcher(`/faults?includeCleared=${includeCleared}`);
      const parsed = await parseJsonOrThrow(res, 'GET /faults', (raw) => ListFaultsResponse.parse(raw));
      return parsed.faults;
    },
    refetchInterval: 30_000,
  });
}
